module.exports = __webpack_public_path__ + "img/23.b5ee8a95.jpg";